export const HEADER_HEIGHT = 72;
export const COMMON_Z_INDEX = 1000;
export const SIDE_MENU_MIN_WIDTH = 240;
export const PROFILE_COMPLETION_TOP_BAR_HEIGHT = 34;
export const AI_INTERVIEWS_TOP_BAR_HEIGHT = 48;
